import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";

/**
 * Protege rutas internas del personal de la firma. Si no hay sesión,
 * redirige a /login preservando la ruta de origen. Si la sesión es de un
 * usuario del Portal del cliente (clientId presente, Fase 19), lo redirige
 * a /portal — el backend rechaza esta combinación a nivel de API
 * (PORTAL_USER_FORBIDDEN) si de todos modos intenta llamar un endpoint interno.
 */
export default function ProtectedRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (user?.clientId) {
    return <Navigate to="/portal" replace />;
  }

  return <Outlet />;
}
